import { com } from '@eidu/web'
import AssetViewPage from '../asset/AssetViewPage'
import { KindViewPageProps } from '../KindPages'
import FormSourceView from './FormSourceView'
import getFormContentId = com.eidu.entity.getFormContentId

/**
 * Routes the Form kind through the generic asset view page, swapping the raw-payload Source tab for the read-only
 * visual form editor.
 */
const FormAssetViewPage = (props: KindViewPageProps) => {
  const formId = props.entity.entity.id.toString()
  const formContentId = getFormContentId(props.entity.entity)?.toString()

  return (
    <AssetViewPage
      {...props}
      renderSource={({ content, isLoading }) => (
        <FormSourceView content={content} isLoading={isLoading} formId={formId} formContentId={formContentId} />
      )}
    />
  )
}

export default FormAssetViewPage
